import PdpSharedDetailBust from './PdpSharedDetailBust';
import PdpSharedDetailCondition from './PdpSharedDetailCondition';
import PdpSharedDetailCreator from './PdpSharedDetailCreator';
import PdpSharedDetailDealerLocation from './PdpSharedDetailDealerLocation';
import PdpSharedDetailDealerReference from './PdpSharedDetailDealerReference';
import PdpSharedDetailDiameter from './PdpSharedDetailDiameter';
import PdpSharedDetailDimensions from './PdpSharedDetailDimensions';
import PdpSharedDetailHip from './PdpSharedDetailHip';
import PdpSharedDetailInseam from './PdpSharedDetailInseam';
import PdpSharedDetailItemLocation from './PdpSharedDetailItemLocation';
import PdpSharedDetailLeadTime from './PdpSharedDetailLeadTime';
import PdpSharedDetailLength from './PdpSharedDetailLength';
import PdpSharedDetailManufactureDate from './PdpSharedDetailManufactureDate';
import PdpSharedDetailMarkedSize from './PdpSharedDetailMarkedSize';
import PdpSharedDetailMaterialNotes from './PdpSharedDetailMaterialNotes';
import PdpSharedDetailMaterialsAndTechniques from './PdpSharedDetailMaterialsAndTechniques';
import PdpSharedDetailMedium from './PdpSharedDetailMedium';
import PdpSharedDetailMetal from './PdpSharedDetailMetal';
import PdpSharedDetailOrigin from './PdpSharedDetailOrigin';
import PdpSharedDetailPeriod from './PdpSharedDetailPeriod';
import PdpSharedDetailProductionType from './PdpSharedDetailProductionType';
import PdpSharedDetailSetSize from './PdpSharedDetailSetSize';
import PdpSharedDetailReference from './PdpSharedDetailReference';
import PdpSharedDetailSeatHeight from './PdpSharedDetailSeatHeight';
import PdpSharedDetailShoulderToHem from './PdpSharedDetailShoulderToHem';
import PdpSharedDetailStone from './PdpSharedDetailStone';
import PdpSharedDetailStoneCut from './PdpSharedDetailStoneCut';
import PdpSharedDetailStyleOf from './PdpSharedDetailStyleOf';
import PdpSharedDetailVersions from './PdpSharedDetailVersions';
import PdpSharedDetailWaist from './PdpSharedDetailWaist';
import PdpSharedDetailWear from './PdpSharedDetailWear';
import PdpSharedDetailWeight from './PdpSharedDetailWeight';
import * as pdpDetailsMessages from '../messages/pdpDetailsMessages';

const VERTICAL_ART = 'art';
const VERTICAL_JEWELRY = 'jewelry';

const details = {
    ARTIST: { DetailComponent: PdpSharedDetailCreator, title: pdpDetailsMessages.artistTitle },
    BRAND: { DetailComponent: PdpSharedDetailCreator, title: pdpDetailsMessages.brandTitle },
    BUST: { DetailComponent: PdpSharedDetailBust, title: pdpDetailsMessages.chestTitle },
    CONDITION: {
        DetailComponent: PdpSharedDetailCondition,
        title: pdpDetailsMessages.conditionTitle,
    },
    CREATOR: { DetailComponent: PdpSharedDetailCreator, title: pdpDetailsMessages.creatorTitle },
    DATE_OF_MANUFACTURE: {
        DetailComponent: PdpSharedDetailManufactureDate,
        title: pdpDetailsMessages.dateOfManufactureTitle,
        [VERTICAL_ART]: {
            DetailComponent: PdpSharedDetailManufactureDate,
            title: pdpDetailsMessages.creationYearTitle,
        },
    },
    DESIGNER: {
        DetailComponent: PdpSharedDetailCreator,
        title: pdpDetailsMessages.designerTitle,
        [VERTICAL_JEWELRY]: {
            DetailComponent: PdpSharedDetailCreator,
            title: pdpDetailsMessages.creatorTitle,
        },
    },
    DEALER_LOCATION: {
        DetailComponent: PdpSharedDetailDealerLocation,
        title: pdpDetailsMessages.sellerLocationTitle,
        [VERTICAL_ART]: {
            DetailComponent: PdpSharedDetailDealerLocation,
            title: pdpDetailsMessages.galleryLocationTitle,
        },
    },
    DEALER_REFERENCE: {
        DetailComponent: PdpSharedDetailDealerReference,
        title: pdpDetailsMessages.dealerReferenceTitle,
    },
    DIAMETER: { DetailComponent: PdpSharedDetailDiameter, title: pdpDetailsMessages.diameterTitle },
    DIMENSIONS: {
        DetailComponent: PdpSharedDetailDimensions,
        title: pdpDetailsMessages.dimensionsTitle,
    },
    HIP: { DetailComponent: PdpSharedDetailHip, title: pdpDetailsMessages.hipTitle },
    INSEAM: { DetailComponent: PdpSharedDetailInseam, title: pdpDetailsMessages.inseamTitle },
    IN_THE_STYLE_OF: {
        DetailComponent: PdpSharedDetailStyleOf,
        title: pdpDetailsMessages.inTheStyleOfTitle,
    },
    ITEM_LOCATION: {
        DetailComponent: PdpSharedDetailItemLocation,
        title: pdpDetailsMessages.itemLocationTitle,
    },
    LENGTH: { DetailComponent: PdpSharedDetailLength, title: pdpDetailsMessages.lengthTitle },
    MARKED_SIZE: {
        DetailComponent: PdpSharedDetailMarkedSize,
        title: pdpDetailsMessages.markedSizeTitle,
    },
    MATERIALS_AND_TECHNIQUES: {
        DetailComponent: PdpSharedDetailMaterialsAndTechniques,
        title: pdpDetailsMessages.materialsAndTechniquesTitle,
    },
    MATERIAL_NOTES: {
        DetailComponent: PdpSharedDetailMaterialNotes,
        title: pdpDetailsMessages.materialNotesTitle,
    },
    METAL: { DetailComponent: PdpSharedDetailMetal, title: pdpDetailsMessages.metalTitle },
    MOVEMENT_AND_STYLE: {
        DetailComponent: PdpSharedDetailStyleOf,
        title: pdpDetailsMessages.movementAndStyleTitle,
    },
    MEDIUM: { DetailComponent: PdpSharedDetailMedium, title: pdpDetailsMessages.mediumTitle },
    OF_THE_PERIOD: {
        DetailComponent: PdpSharedDetailStyleOf,
        title: pdpDetailsMessages.ofThePeriodTitle,
    },
    PLACE_OF_ORIGIN: {
        DetailComponent: PdpSharedDetailOrigin,
        title: pdpDetailsMessages.originTitle,
    },
    PERIOD: { DetailComponent: PdpSharedDetailPeriod, title: pdpDetailsMessages.periodTitle },
    PRODUCTION_TIME: {
        DetailComponent: PdpSharedDetailLeadTime,
        title: pdpDetailsMessages.leadTimeTitle,
    },
    PRODUCTION_TYPE: {
        DetailComponent: PdpSharedDetailProductionType,
        title: pdpDetailsMessages.productionTypeTitle,
    },
    REFERENCE_NUMBER: {
        DetailComponent: PdpSharedDetailReference,
        title: pdpDetailsMessages.referenceNumberTitle,
    },
    SEAT_HEIGHT: {
        DetailComponent: PdpSharedDetailSeatHeight,
        title: pdpDetailsMessages.seatHeightTitle,
    },
    SET_SIZE: { DetailComponent: PdpSharedDetailSetSize, title: pdpDetailsMessages.setSizeTitle },
    SHOULDER_TO_HEM: {
        DetailComponent: PdpSharedDetailShoulderToHem,
        title: pdpDetailsMessages.shoulderToHemTitle,
    },
    STONE: { DetailComponent: PdpSharedDetailStone, title: pdpDetailsMessages.stoneTitle },
    STONE_CUT: {
        DetailComponent: PdpSharedDetailStoneCut,
        title: pdpDetailsMessages.stoneCutTitle,
    },
    WAIST: { DetailComponent: PdpSharedDetailWaist, title: pdpDetailsMessages.waistTitle },
    WEAR: { DetailComponent: PdpSharedDetailWear, title: pdpDetailsMessages.wearTitle },
    WEIGHT: { DetailComponent: PdpSharedDetailWeight, title: pdpDetailsMessages.weightTitle },
    VERSIONS: { DetailComponent: PdpSharedDetailVersions, title: pdpDetailsMessages.versionsTitle },
};

export function getDetailInfo(detail, vertical) {
    if (details[detail]) {
        return details[detail][vertical] || details[detail] || {};
    }
    return {};
}
